module.exports = __webpack_public_path__ + "static/media/project-image-2-big.3c5d45fb.png";